import { HAS_WINDOW } from '@eventbrite/feature-detection';
import Cookies from 'cookies-js';

const ORGANIZER_COOKIE = 'ebOrganizerId';

/**
 * Gets the current URL path for cookie setting
 * @returns current page pathname
 */
const getUrlPath = (): string => {
  if (!HAS_WINDOW) {
    return '/';
  }
  return window.location.pathname;
};

/**
 * Saves organizer ID to cookie for follow action after login
 * @param organizerId - The organizer ID to save
 */
export const saveOrganizerIdInCookie = (organizerId: string): void => {
  if (!HAS_WINDOW) {
    return;
  }

  Cookies.set(ORGANIZER_COOKIE, organizerId, {
    path: getUrlPath(),
    secure: true,
    expires: 300,
  });
};
